import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

export default class Instructions extends Component {
  render() {
    return (
      <section className="instructions">

        <Router>
          <Switch>
            <Route exact path="/chatbot-landing/">
              <h2>ChatBot Commands</h2>

              <table>
                <thead>
                  <tr>
                    <th>Command</th>
                    <th width="80%">Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>!sjdiscord</td>
                    <td>
                      Check out the official St. Jude PLAY LIVE Discord to meet other
                      fundraisers, ask questions, chat with staff and brainstorm
                      ideas. Join us! http://discord.gg/stjudeplaylive
                    </td>
                  </tr>
                  <tr>
                    <td>!sjgiftshop</td>
                    <td>
                      Support the kids of St. Jude with a unique gift from our online
                      St. Jude Gift Shop! Shop here: https://giftshop.stjude.org/
                    </td>
                  </tr>
                  <tr>
                    <td>!plcreative</td>
                    <td>
                      Unite with content creators in the St. Jude PLAY LIVE Creative
                      Season campaign to cure childhood cancer! Whether you’re a
                      crafting expert, aspiring chef, coding wizard, or dabble in any
                      other creative field, you can put your skills on display while
                      raising funds and awareness for the lifesaving mission of St.
                      Jude. Learn more at http://playlivecreative.stjude.org
                    </td>
                  </tr>
                  <tr>
                    <td>!creativetotal</td>
                    <td>
                      Together with the entire St. Jude PLAY LIVE Creative Season
                      community, we have raised{" "}
                      <span className="b_em">
                        [total amount raised through St. Jude PLAY LIVE Creative
                        Season]
                      </span>{" "}
                      for the kids of St. Jude!
                    </td>
                  </tr>
                  <tr>
                    <td>!sjstatus</td>
                    <td>
                      Confirms if your chatbot is connected to your Tiltify campaign
                    </td>
                  </tr>
                  <tr>
                    <td>!sjcommands</td>
                    <td>
                      For a full list of chatbot commands go to
                      https://www.stjude.org/playlivechatbot.
                    </td>
                  </tr>
                  <tr>
                    <td>!sjmatching</td>
                    <td>
                      Looking for an easy way to double or even triple your donation
                      to St. Jude? Ask your employer if they will match your donation
                      to St. Jude. Visit: https://www.stjude.org/SJPLmatch or email
                      matchinggifts@stjude.org for more info.
                    </td>
                  </tr>
                  <tr>
                    <td>!sjraised</td>
                    <td>
                      Our community has raised
                      <span className="b_em">[raised amount]</span> for the kids of
                      St. Jude! Help us reach our fundraising goal of
                      <span className="b_em">[goal amount]</span> by donating here:
                      [campaign donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>!sjgoal</td>
                    <td>
                      Our community has raised
                      <span className="b_em">[raised amount] </span> for the kids of
                      St. Jude! Help us reach our fundraising goal of{" "}
                      <span className="b_em"> [goal amount] </span>by donating here:
                      [campaign donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>!sjmilestones</td>
                    <td>
                      Help unlock our St. Jude campaign milestones! [list of
                      milestones] Donate now: [campaign's donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>!sjnextmilestone</td>
                    <td>
                      My next St. Jude campaign milestone at:{" "}
                      <span className="b_em">[milestone dollar amount]</span> will be
                      to [milestone text]. Let’s go!
                    </td>
                  </tr>
                  <tr>
                    <td>!sjdonate</td>
                    <td>
                      I am raising money for the kids of St. Jude Children's Research
                      Hospital. Help me reach my goal by donating now at [campaign's
                      donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>!sjstory</td>
                    <td>
                      St. Jude Inspire tells the stories of St. Jude Children's
                      Research Hospital to inspire trust, hope and faith in the
                      mission that drives us: Finding cures. Saving children. Learn
                      more about St. Jude patients, families and supporters at
                      https://stjude.org/inspire!
                    </td>
                  </tr>
                  <tr>
                    <td>!sjfact</td>
                    <td>
                      Chatbot will post random facts about St. Jude Children's
                      Research Hospital
                    </td>
                  </tr>
                  <tr>
                    <td>!plhypetrain</td>
                    <td>
                      Activate the St. Jude PLAY LIVE Hypetrain by donating to our
                      Tiltify campaign. Keep it going to see how high we can level up
                      for the kids of St. Jude!
                    </td>
                  </tr>
                  <tr>
                    <td>!plabout</td>
                    <td>
                      St. Jude PLAY LIVE is the video game charity platform supporting
                      St. Jude Children’s Research Hospital. Whether it's Fortnite,
                      League of Legends or Animal Crossing, you can play your favorite
                      video games while helping raise funds and awareness for the
                      lifesaving mission of St. Jude. Learn more at
                      http://playlive.stjude.org
                    </td>
                  </tr>
                  <tr>
                    <td>!sjpart</td>
                    <td>Removes chatbot from your channel</td>
                  </tr>
                  <tr>
                    <td>!prizeseasontotal</td>
                    <td>
                      Together with the entire St. Jude PLAY LIVE community, we have
                      raised{" "}
                      <span className="b_em">
                        [total amout raised through St. Jude PLAY LIVE]{" "}
                      </span>{" "}
                      for the kids of St. Jude!
                    </td>
                  </tr>
                  <tr>
                    <td>!gcxtotal</td>
                    <td>
                      Together with the entire GCX community, we have raised raised{" "}
                      <span className="b_em">
                        [total amount raised through GCX event]{" "}
                      </span>{" "}
                      for the kids of St. Jude!
                    </td>
                  </tr>
                  <tr>
                    <td>!5dono</td>
                    <td>
                      Your $5 donation could provide an isolation gown for a parent of
                      a St. Jude kid. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!6dono</td>
                    <td>
                      Your $6 donation could provide an IV tubing kit for a St. Jude
                      patient. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!7dono</td>
                    <td>
                      Your $7 donation could provide a blank medical teaching doll
                      that helps St. Jude patients understand medical treatment
                      procedures Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!10dono</td>
                    <td>
                      Your $10 donation could provide a new toy for the hospital play
                      areas. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!22dono</td>
                    <td>
                      Your $22 donation can help provide rehab weights for a St. Jude
                      kid to help them regain strength and mobility Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!25dono</td>
                    <td>
                      Your $25 donation can help provide a No More Chemo Party for a
                      kid at St. Jude to help them celebrate the completion of
                      chemotherapy treatment. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!30dono</td>
                    <td>
                      Your $30 donation could cover a full day of meals for a St. Jude
                      family. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!50dono</td>
                    <td>
                      Your $50 donation can help provide art supplies for kids at St.
                      Jude. At St. Jude patients are encouraged to express themselves
                      through numerous art activities. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!57dono</td>
                    <td>
                      Your $57 donation can help provide necessities for parents who
                      may have hurriedly left home after their child’s diagnosis.
                      Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!75dono</td>
                    <td>
                      Your $75 donation could provide video games for kids at St.
                      Jude. While undergoing treatment, video games offer patients a
                      welcome way to pass the time. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!100dono</td>
                    <td>
                      Your $100 donation can help provide a patient wagon at St. Jude.
                      Red wagons are the preferred mode of travel through the halls of
                      the hospital for our youngest patients. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!200dono</td>
                    <td>
                      Your $200 donation can help provide platelet count tests for
                      four St. Jude patients. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!300dono</td>
                    <td>
                      Your $300 donation could help provide one red blood cell
                      transfusion for a St. Jude patient. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!500dono</td>
                    <td>
                      Your $500 donation could help provide one platelet transfusion
                      for a St. Jude patient. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!1000dono</td>
                    <td>
                      Your $1000 donation could help provide two-thirds of the cost of
                      one day of chemotherapy for a St. Jude patient. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!2500dono</td>
                    <td>
                      Your $2500 donation could help provide 16 days of oxygen for a
                      St. Jude patient. Thank you!
                    </td>
                  </tr>
                  <tr>
                    <td>!5000dono</td>
                    <td>
                      Your $5000 donation could help provide the daily room rate of
                      the ICU for a St. Jude patient. Thank you!
                    </td>
                  </tr>
                </tbody>
              </table>
            </Route>
            <Route exact path="/discord-landing/">
              <h2>Discord commands</h2>

              <table>
                <tbody>
                  <tr>
                    <td>/sjsetup</td>
                    <td>
                      Enter your Tiltify donation url to connect the chatbot to your campaign 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjstatus</td>
                    <td>
                      Confirms if your chatbot is connected to your Tiltify campaign]
                    </td>
                  </tr>
                  <tr>
                    <td>/sjcommands</td>
                    <td>
                      For a full list of chatbot commands go to https://www.stjude.org/discordbot
                    </td>
                  </tr>
                  <tr>
                    <td>/sjraised /sjgoal</td>
                    <td>
                      Our community has raised [raised amount] for the kids of St. Jude! Help us reach our fundraising goal of [goal amount] by donating here: [campaign donation url] 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjdonate</td>
                    <td>
                      I am raising money for the kids of St. Jude Children's Research Hospital. Help me reach my goal by donating now at [campaign's donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>/sjmilestones</td>
                    <td>
                      Help unlock our St. Jude campaign milestones! [list of milestones] Donate now: [campaign's donation url]
                    </td>
                  </tr>
                  <tr>
                    <td>/sjnextmilestone</td>
                    <td>
                      My next St. Jude campaign milestone at: [milestone dollar amount] will be to [milestone text]. Let’s go!
                    </td>
                  </tr>
                  <tr>
                    <td>/sjpolls</td>
                    <td>
                      Check out our active St. Jude campaign polls! [list of active polls] Donate now to place your vote: [campaign's donation url] 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjrecent</td>
                    <td>
                      Thank you to these amazing recent donors for supporting St. Jude kids! Want to join in support? Donate here: [campaign's donation url] 
                    </td>
                  </tr>
                  <tr>
                    <td>/prizeseasontotal</td>
                    <td>
                      Together with the entire St. Jude PLAY LIVE community, we have raised [total amout raised through St. Jude PLAY LIVE] for the kids of St. Jude!
                    </td>
                  </tr>
                  <tr>
                    <td>/creativetotal</td>
                    <td>
                      Together with the entire St. Jude PLAY LIVE Creative Season community, we have raised [total amount raised through St. Jude PLAY LIVE Creative Season] for the kids of St. Jude! 
                    </td>
                  </tr>
                  <tr>
                    <td>/gcxtotal</td>
                    <td>
                      Together with the entire GCX community, we have raised [total amount raised through GCX event] for the kids of St. Jude! 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjteamtotal</td>
                    <td>
                      Our team has raised [raised amount] for the kids of St. Jude! Help us reach our team goal of [goal amount] for the kids of St. Jude by donating here: [team donate link] 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjteamreg</td>
                    <td>
                      Want to join our team in supporting the kids of St. Jude? Register here: [Tiltify team landing page for registration] 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjfact</td>
                    <td>
                      Chatbot will post random facts about St. Jude Children's Research Hospital 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjstory</td>
                    <td>
                      St. Jude Inspire tells the stories of St. Jude Children's Research Hospital to inspire trust, hope and faith in the mission that drives us: Finding cures. Saving children. Learn more about St. Jude patients, families and supporters at https://stjude.org/inspire!
                    </td>
                  </tr>
                  <tr>
                    <td>/sjcommands</td>
                    <td>
                      For a full list of chatbot commands go to https://www.stjude.org/discordbot. 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjgiftshop</td>
                    <td>
                      Support the kids of St. Jude with a unique gift from our online St. Jude Gift Shop! Shop here: https://giftshop.stjude.org/ 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjmatching</td>
                    <td>
                      Looking for an easy way to double or even triple your donation to St. Jude? Ask your employer if they will match your donation to St. Jude. Visit: https://www.stjude.org/SJPLmatch or email matchinggifts@stjude.org for more info. 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjdono</td>
                    <td>
                      Choose an amount to show the impact of your donation to St. Jude 
                    </td>
                  </tr>
                  <tr>
                    <td>/sjdiscord</td>
                    <td>
                      Check out the official St. Jude PLAY LIVE Discord to meet other fundraisers, ask questions, chat with staff and brainstorm ideas. Join us! http://discord.gg/stjudeplaylive
                    </td>
                  </tr>
                </tbody>
              </table>
            </Route>
          </Switch>
        </Router>
      </section>
    );
  }
}
